var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',{staticClass:"home-title"},[_vm._v("👍 Compre ou Venda 👎")]),_c('ProdutoBusca'),_c('ProdutoLista')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }